import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoPivotDataSourceMixin from './KendoPivotDataSourceMixin'

export default {
    name: 'kendo-pivotdatasource',
    mixins: [ KendoPivotDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/index.js